import React from "react";
// import {VelocityComponent, VelocityTransitionGroup} from 'velocity-react'

export default class AnimatedContainer extends React.Component {
  animateHeight() {
    let el = $(this.contents);
    const height = el.outerHeight();
    const container = $(this.container);
    container.velocity({ height: height + 10 }, { duration: 500 });
  }

  componentDidMount() {
    this.animateHeight();
  }

  componentDidUpdate() {
    this.animateHeight();
  }

  render() {
    return (
      <div
        ref={el => this.container = el}
        className={this.props.classNames}
        style={{ overflow: "hidden" }}>
        <div ref={el => this.contents = el}>{this.props.children}</div>
      </div>
    );
  }
}
